import {useState} from 'react';
import TagManager from 'react-gtm-module'
import {motion} from 'framer-motion';

import {authAnimation} from '../../animations';

const TalkToUs = () => {

    const [showWeChat, setShowWeChat] = useState(false)

    const tagManagerArgs = {
        // gtmId: 'GTM-KF7KJJF',
        dataLayerName: 'PageDataLayer',
        dataLayer: {
            'event' : 'initialiseTalkToUs'
        }
    }
    TagManager.dataLayer(tagManagerArgs)

    const renderImessage = () => {

        const isApple = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
        if( isApple ) {
            return(
                <div className="tablet imessage is-family-tertiary">
                    <a href="https://bcrw.apple.com/urn:biz:f12888f2-70d0-4a92-82c5-69fc4be5b811?biz-intent-id=Business-Ambassador"  target="_blank" rel="noopener noreferrer">iMessage</a>
                </div>
            )
        } else {
            return(
                <div className="tablet imessage is-family-tertiary">
                    <a href="sms:+447723575414?&body=Hi%20UoG%2C%20..."  target="_blank" rel="noopener noreferrer">SMS</a>
                </div>
            )
        }
    }

    return (
        <motion.div
        layoutId="auth"
        key="talkToUs"
        variants={authAnimation}
        initial="initial"
        animate="visible"
        exit="exit">

            <h3>Talk to us here</h3>

            <div className="tablets">
                <div id="LP_DIV_1615289211519"></div>
                <div id="LP_DIV_1615288897371"></div>
                <div className="tablet messenger is-family-tertiary">
                    <a href="https://m.me/uniofglos"  target="_blank" rel="noopener noreferrer">Messenger</a>
                </div>

                {renderImessage()}

                <div className="tablet wechat is-family-tertiary">
                    <button className="btn cursor" onClick={(e)=> setShowWeChat(!showWeChat)} target="_blank" rel="noopener noreferrer">WeChat</button>
                    <div className={`wechat-content ${showWeChat? 'open':''}`}>
                        <a href="https://weixin.qq.com/r/7jnQyP-EbqIRrbur92z8" target="_blank" rel="noopener noreferrer">
                            <img src="https://chart.googleapis.com/chart?chs=100x100&cht=qr&chl=https%3A%2F%2Fweixin.qq.com%2Fr%2F7jnQyP-EbqIRrbur92z8&chld=L%7C1" alt="QR code" style={{width:'100%'}} />
                        </a>
                    </div>
                </div>
            </div>

            <p className="text-center is-family-tertiary is-7">Chat to our students about courses &amp; uni life on Unibuddy.</p>

            <ul className="tablets">
                <li className="tablet is-family-tertiary unibuddy">
                    <a href="https://www.glos.ac.uk/talk-to-a-student/"  target="_blank" rel="noopener noreferrer">Unibuddy</a>
                </li>
            </ul>
        </motion.div>
    );
}

export default TalkToUs;